module.exports = {
  src: __webpack_public_path__ + "static/media/individuals_00030.07c5e9b1.jpg",
  width: 2400,
  height: 3000,
  bytes: 364944,
  type: "jpg",
};
module.exports.toString = function() {
  return __webpack_public_path__ + "static/media/individuals_00030.07c5e9b1.jpg";
};


//////////////////
// WEBPACK FOOTER
// ./src/core/images/galleries/individuals/individuals_00030.jpg
// module id = 473
// module chunks = 0